import { Component, Input } from '@angular/core';
import { AnalyticsService } from 'smartauction-frontend-micro-library';
import { DynamicBannerAlert } from 'src/shared/models/dynamic-banner-alert.model';
import { TranslocoDirective } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-auction-summary-result-item-banner',
    templateUrl: './auction-summary-result-item-banner.component.html',
    styleUrls: ['./auction-summary-result-item-banner.component.scss'],
    imports: [TranslocoDirective, CommonModule, RouterLink]
})
export class AuctionSummaryResultItemBannerComponent {
  @Input() tenantName;

  @Input() bannerAlerts: DynamicBannerAlert[];

  get scrollPosition() {
    return window.scrollY;
  }

  constructor(private readonly _analyticsService: AnalyticsService) {}

  handleArbitrationClick(bannerAlert: DynamicBannerAlert) {
    const linkDescriptionWithId = `Case Opened (${bannerAlert.alertContent.claimNumber})`;
    this._analyticsService.fireEventOnAnchorClick(linkDescriptionWithId, bannerAlert.alertContent.link);
  }
}
